import { pick } from 'lodash'
import { track } from './analytics'

export const demoRequested = args => {
  track(
    'Demo Requested',
    pick(args, ['workspaceId', 'workspaceSlug', 'feature', 'userEmail'])
  )
}
